import api from './api';
import { config } from '../config';

export interface User {
  id: number;
  email: string;
  firstName: string;
  lastName: string;
  isActive: boolean;
  isAdmin: boolean;
  lastLogin?: string;
  createdAt: string;
  updatedAt?: string;
  lastPasswordChange?: string;
}

export interface CreateUserRequest {
  email: string;
  firstName: string;
  lastName: string;
  password: string;
  isAdmin: boolean;
}

export interface UpdateUserRequest {
  firstName: string;
  lastName: string;
  isActive: boolean;
  isAdmin: boolean;
}

export interface ChangeUserPasswordRequest {
  userId: number;
  newPassword: string;
}

export const userService = {
  // Récupérer tous les utilisateurs
  getAllUsers: async (): Promise<User[]> => {
    const response = await api.get(config.endpoints.users);
    return response.data;
  },

  // Récupérer un utilisateur par ID
  getUserById: async (id: number): Promise<User> => {
    const response = await api.get(`${config.endpoints.users}/${id}`);
    return response.data;
  },

  // Créer un nouvel utilisateur
  createUser: async (user: CreateUserRequest): Promise<User> => {
    const response = await api.post(config.endpoints.users, user);
    return response.data;
  },

  // Mettre à jour un utilisateur
  updateUser: async (id: number, user: UpdateUserRequest): Promise<User> => {
    const response = await api.put(`${config.endpoints.users}/${id}`, user);
    return response.data;
  },

  // Supprimer un utilisateur
  deleteUser: async (id: number): Promise<void> => {
    await api.delete(`${config.endpoints.users}/${id}`);
  },

  // Activer/Désactiver un utilisateur
  toggleUserStatus: async (id: number): Promise<User> => {
    const response = await api.patch(`${config.endpoints.users}/${id}/toggle-status`);
    return response.data;
  },

  // Changer le mot de passe d'un utilisateur
  changeUserPassword: async (passwordData: ChangeUserPasswordRequest): Promise<void> => {
    await api.post(`${config.endpoints.users}/${passwordData.userId}/change-password`, {
      newPassword: passwordData.newPassword
    });
  },

  // Récupérer les statistiques des utilisateurs
  getUserStats: async (): Promise<{
    totalUsers: number;
    activeUsers: number;
    inactiveUsers: number;
    adminUsers: number;
    regularUsers: number;
  }> => {
    const response = await api.get(`${config.endpoints.users}/stats`);
    return response.data;
  }
};
